<template>
    <div id="pickingInfo">
        <el-row class="clearfix" style="margin-bottom: 15px;">
            <el-col class="fl" :span="2">
                <el-button size="small"  type="warning" @click="backGo()">返回</el-button>
            </el-col>
            <el-col class="fr" :span="1">
                <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;" @click="refresh()"></i>
            </el-col>
        </el-row>
        <el-col class="fl searthPart" style="width: 20%;">
            <p class="headerT">物料转库信息</p>
            <el-form ref="returnForm" :model="returnForm" label-width="120px" :label-position="labelPosition">
                <el-form-item label="物料转库编号:">
                    <el-input :disabled="true" v-model="returnForm.code"></el-input>
                    <i class="iconfont hohofast-copy copyBtn" @click="handleCopy(returnForm.code,$event)"></i>
                </el-form-item>
                <el-form-item label="转出仓库:">
                    <el-input :disabled="true" v-model="returnForm.warehouseTypeOut" ></el-input>
                </el-form-item>
                <el-form-item label="转入仓库:">
                    <el-input :disabled="true" v-model="returnForm.warehouseTypeInput" ></el-input>
                </el-form-item>
                <el-form-item label="操作人:">
                    <el-input :disabled="true" v-model="returnForm.operatorUser" ></el-input>
                </el-form-item>
                <el-form-item label="状态:">
                    <el-input :disabled="true" value="已完成"></el-input>
                </el-form-item>
                <el-form-item label="提交时间:">
                    <el-input :disabled="true" v-model="returnForm.createTime" ></el-input>
                </el-form-item>
                <el-form-item label="备注信息:">
                    <el-input :disabled="true" v-model="returnForm.memo" ></el-input>
                </el-form-item>
            </el-form>
        </el-col>
        <el-col class="fr" style="width: 78%;">
            <el-card class="box-card fr" style="width: 100%;">
                <el-table
                    :data="returnData"
                    border
                    :header-cell-style="{'text-align':'center'}"
                    :summary-method="getSummaries"
                    show-summary
                    style="width: 100%">
                    <el-table-column
                        align="center"
                        type="index"
                        width="50"
                        label="序号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="materialCode"
                        label="物料编号">
                    </el-table-column> 
                    <el-table-column
                        align="center"
                        prop="modelName"
                        label="型号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="materialName"
                        label="物料名称">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="sum"
                        width="100"
                        label="到货数量">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        label="操作">
                        <template slot-scope="scope">
                        <el-button @click.stop="showSerialNumber(scope.$index, scope.row)" type="text" size="small">查看序列号</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 查看序列号弹出框 -->
                <el-dialog  class="dialog-content" :visible.sync="dialogTableVisible">
                    <el-row 
                        class="dialog-code-content" 
                        element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading">
                        <el-col v-for="(item,index) in checkCodeList" v-if="item != ''" :key="index" :span="6">
                            <p>{{item}}</p>
                        </el-col>
                    </el-row>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogTableVisible = false">关闭</el-button>
                    </div>
                </el-dialog>
                <!--分页-->
                <el-col :span="24" class="toolbar">
                    <div class="pagination">
                        <el-pagination
                            background
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="pages.page"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="pages.pageSize"
                            layout="total, sizes, prev, pager, next"
                            :total="pages.total">
                        </el-pagination>
                    </div>
                </el-col>
            </el-card>
        </el-col>
    </div>
</template>

<script>
    let moment = require("moment");
    import clip from '@/util/clipboard'
    import {
        transferLibraryDetails,
        transferLibraryDetailsList
    } from "../../api/api";
    export default {
        name: 'pickingInfo',
        components: {},
        data () {
            return {
                checkCodeList:[],
                dialogTableVisible: false, //弹出框
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                valueTime:'',
                orderId:'',
                labelPosition:'left',
                returnForm:{},
                returnData: []
            }
        },
        created(){
            this.$destroy(); //销毁生命周期
            if (!this.$route.query.orderId) {
                this.orderId = sessionStorage.getItem('saveOrderId');
            }else{
                let orderId = this.$route.query.orderId
                this.orderId = orderId
            }
            this.getTransferLibraryDetails()
            this.getTransferLibraryDetailsList()
        },
        methods: {
            //获取订单详情
            getTransferLibraryDetails() {
                let para={
                    id: this.orderId
                }
                transferLibraryDetails(para).then(res => {          
                    if (res.data.status==100) { 
                        this.returnForm = res.data.results.info
                        this.returnForm.createTime = this.filters.formatDate(this.returnForm.createTime);
                        sessionStorage.setItem('saveOrderId', res.data.results.info.id);            
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //获取订单详情
            getTransferLibraryDetailsList() {
                let para={
                    id: this.orderId,
                    startRow: this.pages.page,
                    pageSize: this.pages.pageSize
                }
                transferLibraryDetailsList(para).then(res => {          
                    if (res.data.status==100) { 
                        this.returnData = res.data.results.list
                        this.pages.total = res.data.results.total            
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            showSerialNumber(index, row) {
                console.log(Object.assign({}, row))
                this.dialogTableVisible = true
                this.checkCodeList = Object.assign({}, row).sn.split(',')
            },
            //复制内容
            handleCopy(text, event) {
                clip(text, event)
                // console.log(text)
            },
            //返回上一页
            backGo() {
                this.$router.push({
                    path:'/materChangeStoreManage'
                })
            },
            refresh() {
                this.getTransferLibraryDetails()
                this.getTransferLibraryDetailsList()
            },
            getSummaries(param) {
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '合计';
                        return;
                    }
                    if (index === 6) {
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));

                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        sums[index] += '';
                    } else {
                        sums[index] = '';
                    }
                });
                if (sums[5] > 0) {
                    sums[7] = this.toThousands2(sums[7]);
                }
                return sums;
            },
            //金额转化函数
            toThousands2(num) {
                num = num.toString().replace(/\$|\,/g,'');
                if(isNaN(num))
                num = "0";
                var sign = (num == (num = Math.abs(num)));
                num = Math.floor(num*100+0.50000000001);
                var cents = num%100;
                num = Math.floor(num/100).toString();
                if(cents<10)
                cents = "0" + cents;
                for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
                num = num.substring(0,num.length-(4*i+3))+','+
                num.substring(num.length-(4*i+3));
                return (((sign)?'':'-') + num + '.' + cents);
            },
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.getTransferLibraryDetailsList()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.getTransferLibraryDetailsList()
            }
        },
        computed: {
        },
        watch: {
          
        },
    
    }
</script>

<style type="text/css" lang="scss" scoped>
    #pickingInfo{
        font-size: 14px;
        .copyBtn{font-size: 24px;cursor: pointer;display:block;float: right;}
        .el-input{width: 85%;}
        .headerT{font-size: 16px;margin:0 0 15px 0;}
        .toolbar{margin: 20px 0;}
        .el-button+.el-button {
            margin-left: 0px;
        }
        .el-step__line{background-color: #1abc9c;}
        .el-step__icon-inner{color:#1abc9c;}
        /*.el-step__icon{width: 10px;height: 10px;}*/
        .el-step__icon.is-text{border-color: #1abc9c;}
    }
    .dialog-content{
        width:900px;
        margin:0 auto;
        .dialog-code-content{
            text-align: center;
            .el-col{
                p{
                    border: 1px solid #e3e3e3;
                    line-height: 40px
                }
                
            }
        }
    }
  
</style>



// WEBPACK FOOTER //
// materChangeStoreInfo.vue?55532049